import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const InfoCards = styled.div`
  & > div:first-of-type {
    margin: 0 auto;
    margin-right: 10px;

    ${mq({
      width: ['80%', '80%', '50%'],
    })}
  }
  
  & > div:nth-of-type(2) {
    ${mq({
      margin: ['20px auto', '20px auto', '0 10px 0'],
      width: ['80%', '80%', '50%'],
    })}
  }

  ${mq({
    display: ['block', 'block', 'flex'],
  })}
`
